/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Video {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Video as VideoModule } from "@bw/modules"

const Video = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  backgroundVariant,
  video,
}) => {
  if (!video) {
    return null
  }

  const url =
    video.source?.value === "youtube"
      ? `https://www.youtube.com/watch?v=${video.youtubeId}`
      : video.source?.value === "vimeo"
      ? `https://vimeo.com/${video.vimeoId}`
      : null

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        backgroundVariant,
      }}
      containerSize="small"
    >
      <VideoModule url={url} poster={video?.poster?.url} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on VideoModule {
 *   ...VideoModuleFragment
 * }
 *
 * This is also what you will get in the props of your LogoGrid
 * resolver component.
 */
export const query = graphql`
  fragment VideoModuleFragment on VideoModule {
    video {
      poster {
        url
      }
      youtubeId
      vimeoId
      source {
        value
      }
    }
  }
`

export { Video }
